export default __webpack_public_path__ + "static/media/instagram 2.c88d8b6a.svg";